/**
 * Created by user on 3/2/2017.
 */
var DetailValidationOdsController = (function () {
    function DetailValidationOdsController(topic, env, socket, $scope, Dialog, settings, notify, $state) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.settings = settings;
        this.notify = notify;
        this.$state = $state;
        this.OPP_VERSION_4 = 4;
        this.datesValid = false;
        this.showFilterBtn = true;
        this.isFilterSet = true;
        this.custNumber = '';
        this.custName = '';
        this.soNumber = '';
        this.invoiceNumber = '';
        this.bpNumber = '';
        this.isChargeAgreement = false;
        this.bpName = '';
        this.brandFam = [];
        this.siteNum = '';
        this.filters = [];
        this.isFilterToggled = false;
        this.isODSfilter = true;
        this.filterToggles = {
            countries: true,
            sviStats: false,
            dmtStats: false,
            dmtSubStats: false,
            teams: false,
            vap: false,
            isODSfilter: true
        };
        this.processingODS = false;
        this.validationSuccess = false;
        this.socket.forward('odsData.list.creation.done', this.$scope);
        this.$scope.$on('socket:odsData.list.creation.done', function (event, data) {
            _this.showProgress = false;
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            if (data.results.msg) {
                var msg = data.results.msg.message || data.results.msg;
                _this.notify.error('There was an error attempting to perform your ODS Search - ' + msg + '.  Please contact the System Administrators for guidance');
            }
            else {
                // console.log(data.results);
                if (!data.results.error) {
                    _this.odsDataList = data.results;
                    _this.createOdsDialog();
                }
                else {
                    var pushMessages = {
                        msgLines: ['No Items Found']
                    };
                    _this.Dialog.showOnlyMessage(pushMessages);
                }
            }
        });
        this.socket.forward('odsData.validation.done', this.$scope);
        this.$scope.$on('socket:odsData.validation.done', function (event, data) {
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            alert('validation done');
        });
        this.socket.forward('ods.validation.process', this.$scope);
        this.$scope.$on('socket:ods.validation.process', function (event, data) {
            _this.processingODS = false;
            _this.topic.goeFired = false; //Set flag to unblock goe button and display message
            _this.isChargeAgreement = !!data.isChargeAgreement;
            if (data.err === true) {
                // console.warn('Error on validation of ODS , $detail.validation.ods.component.ts =>', data.msg);
                var msg = data.msg && data.msg.message || data.msg;
                _this.notify.error('There was an error attempting to perform Validation for Sales Order ' + _this.selectedSO + ': ' + msg + '.  Please contact the System Administrators for guidance');
            }
            else {
                _this.validationSuccess = true;
                // console.warn('Finished processing Validation on ' + this.selectedSO + ' =>');
                _this.notify.success('Auto-Validation successfully completed for ' + _this.selectedSO);
                //Could be a couple of scenarios here...
                //1 - user has clicked ODS Search when SAP data already present - this will result in a Dispute
                //2 - no SAP data present...
                var opp_1 = _this.topic.topic._id.substring(4);
                var unid_1 = _this.topic.topic._id;
                var dispute = opp_1.indexOf('-DIS:');
                if (dispute > -1) {
                    //Strip the dispute details from the id so it's just the opp
                    opp_1 = opp_1.substring(0, dispute);
                }
                // Check if the opps updated by io-ws-sap contain this one
                if (data.opps.indexOf(unid_1) < 0) {
                    // if not, we have to assume a new Dispute was created
                    // data.opps will be an array of _ids updated or created by the sap module...
                    // If there's only 1 and it matches the current _id then we can assume the Validation
                    // was performed on this disbursement, therefore trigger a reload
                    // If not the same, then we can assume a Dispute was created - ask user if they wanna open
                    // If more than 1...
                    if (data.opps.length === 1) {
                        //Ask user if they wanna open the new dispute
                        var items = {
                            icon: 'QUESTION',
                            message: 'The Auto-Validation process has been successful and Dispute <b>' + data.opps[0] + '</b> has been created as a result.<br><br>Do you want to open it now?',
                            title: 'Auto-Validation'
                        };
                        //Ask it...
                        _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                            //If clicked no
                            if (!dResult.confirm) {
                                //Update the topic to append the dispute number (don't bother with history)
                                _this.topic.addDisputeDetails({ unid: data.opps[0] });
                                _this.topic.setActionButtons(); //Make call on the hide/show for the action buttons
                            }
                            else {
                                _this.$state.go('detail.general', {
                                    id: data.opps[0].substring(4)
                                });
                            }
                        });
                    }
                    else {
                        if (!_this.isChargeAgreement) {
                            var ids_1 = '';
                            angular.forEach(data.opps, function (id) {
                                ids_1 = id;
                                if (ids_1.length === 0) {
                                    ids_1 += '<br>' + id;
                                }
                            });
                            //Prepare to ask question...based on event
                            var items = {
                                icon: 'INFO',
                                message: 'The following Disbursements were updated or created as a result of the Auto-Validation:<br><br>' +
                                    ids_1 + '<br><br>Access any new Disputes via the original Disbursement\'s Actions.',
                                title: 'Auto-Validation'
                            };
                            //Block
                            _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                                return false;
                            });
                        }
                    }
                }
                else {
                    //If no general errors object parsed, or they have been but all resolved, all should be good and calcs have been fired
                    if (!_this.isChargeAgreement && angular.isUndefined(data.general_errors) || (angular.isDefined(data.general_errors) && data.general_errors.unresolved === 0)) {
                        //Prompt user...
                        var items = {
                            icon: 'INFO',
                            message: 'The Auto-Validation process has been successful and the Auto-Calculation process has started.<br><br>' +
                                '<b style="color:red">WARNING:</b> &nbsp;Please wait a few seconds before clicking OK - the Calculations may not have completed and ' +
                                'the Disbursement details will be incorrect. &nbsp;If this is the case press F5 to refresh.',
                            title: 'Auto-Validation'
                        };
                        //Ask it...
                        _this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                            //If clicked no
                            if (dResult.confirm) {
                                //If no sap data there, reload the page in order to see the results...ideally update validation code to send sap obby back
                                _this.topic.clearTopic(_this.topic.topic._id.substring(4));
                                _this.socket.emit('module', {
                                    module: {
                                        application: 'dmt',
                                        function: 'loadDataClient',
                                        script: '/detail/general/general',
                                        data: {
                                            opp: opp_1,
                                            unid: unid_1
                                        },
                                        token: _this.env.user.token
                                    }
                                });
                            }
                        });
                    }
                }
            }
        });
    }
    DetailValidationOdsController.prototype.select = function ($event) {
        $event.target.select();
    };
    DetailValidationOdsController.prototype.createOdsDialog = function () {
        var _this = this;
        var isV4OrLater = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_4;
        this.Dialog.createODSList(this.odsDataList, isV4OrLater).then(function (dResult) {
            if (dResult !== null) {
                for (var i = 0; i < dResult.data.itemList.length; i++) {
                    dResult.data.itemList[i].opp = _this.topic.topic.opp;
                    delete dResult.data.itemList[i].$$hashKey;
                    delete dResult.data.itemList[i].brandfam;
                    delete dResult.data.itemList[i].brandfamDesc;
                }
                delete dResult.data.$$hashKey;
                _this.selectedSO = dResult.data.soNumber;
                _this.processingODS = true;
                _this.validationSuccess = false;
                //If the 2nd GOE is needed and has not been performed yet, it will automatically happen during the io-ws-sap run...
                if (_this.topic.is2ndGOENeeded() && !_this.topic.is2ndGOEComplete()) {
                    _this.topic.goeFired = true; //Set flag to block goe button and display message
                }
                _this.socket.emit('module', {
                    module: {
                        bID: _this.topic.topicBrowserID,
                        application: 'dmt',
                        function: 'pushODSItem',
                        script: '/validation/odsTables',
                        //email: this.env.user.email,
                        program: _this.topic.topic.program,
                        iot: _this.topic.topic.iot,
                        soNumber: dResult.data,
                        isChargeAgreement: _this.isChargeAgreement,
                        invoice_numbers: dResult.invoice,
                        id: _this.topic.topic._id,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailValidationOdsController.prototype.$onInit = function () {
        this.ctyCode = this.topic.topic.country;
        if (angular.isDefined(this.topic.topic.gpp_valid) && this.topic.topic.gpp_valid.length > 0) {
            this.custName = angular.isDefined(this.topic.topic.gpp_valid[0].acctname) ? this.topic.topic.gpp_valid[0].acctname : '';
        }
        this.isChargeAgreement = this.topic.topic.isChargeAgreement || false;
    };
    DetailValidationOdsController.prototype.checkValidity = function () {
        if (angular.isDefined(this.startDate) && angular.isDefined(this.endDate) &&
            this.startDate !== null && this.endDate !== null) {
            var range = 0;
            if (angular.isDate(this.startDate) && angular.isDate(this.endDate)) {
                range = Math.round((this.endDate - this.startDate) / (1000 * 60 * 60 * 24));
                if (range > 90) {
                    this.dateError = '* The Start/End Date range (' + range + ' days) is invalid.  Must be no greater than 90 days';
                    this.datesValid = false;
                    return;
                }
            }
            else {
                this.dateError = '* Either Start or End Date is invalid';
                this.datesValid = false;
                return;
            }
        }
        else if (angular.isDefined(this.startDate) && angular.isUndefined(this.endDate)) {
            this.dateError = '* Please enter the End Date';
            this.datesValid = false;
            return;
        }
        else if (angular.isUndefined(this.startDate) && angular.isDefined(this.endDate)) {
            this.dateError = '* Please enter the Start Date';
            this.datesValid = false;
            return;
        }
        this.datesValid = true;
        this.dateError = '';
        /*
                if (typeof this.startDate === 'undefined' || this.startDate === 0
                    || typeof this.endDate === 'undefined' || this.endDate === 0
                    || (this.startDate > this.endDate && (typeof this.endDate !== 'undefined' || this.endDate !== 0))
                    || Math.round((this.endDate - this.startDate) / (1000 * 60 * 60 * 24)) > 90) {
                    this.datesValid = false;
                } else {
                    this.datesValid = true;
                }*/
    };
    DetailValidationOdsController.prototype.filterToggle = function () {
        this.isFilterToggled = !this.isFilterToggled;
    };
    DetailValidationOdsController.prototype.applyFilter = function () {
        this.showProgress = true;
        if (this.brandFam.length === 0) {
            for (var i = 0; i < this.topic.topic.gpp.length; i++) {
                this.brandFam.push();
            }
        }
        var data = {
            service: 'RA',
            parameters: {
                customerNumber: this.custNumber.length > 0 ? this.topic.strRight('0000000000' + this.custNumber, 10) : undefined,
                customerName: this.custName.length > 0 ? this.custName : undefined,
                salesOrderNumber: this.soNumber.length > 0 ? this.topic.strRight('0000000000' + this.soNumber, 10) : undefined,
                SapBillgDocNum: this.invoiceNumber.length > 0 ? this.invoiceNumber : undefined,
                countryCode: this.ctyCode.length > 0 ? this.ctyCode.toUpperCase() : undefined,
                start_date: this.startDate.getFullYear() + ''
            }
        };
        /*
            Example below...
        {
            "service": "RA",
            "parameters": {
                "customerName": "Flexibreak",       <- SoldToCustName
                "customerNumber": "0003698020",     <- SoldToCustNum
                "sales_order_start_date": "2017-06-01",  <-- BillgOrdSalesOrdDate (MAND)
                "sales_order_end_date": "2017-06-30",  <-- BillgOrdSalesOrdDate (MAND)
                "salesOrderNumber": "0060628991",      < -- SapSalesOrdNum
                "countryCode": "ZA"                      < --- SoldToCntryCode2?
                }
        }
    
        */
        // Lose any undefined elements... these may be set or not
        this.loseUndefined(['customerNumber', 'countryCode', 'customerName', 'salesOrderNumber', 'SapBillgDocNum'], data.parameters);
        // Set Start and end dates
        if ((this.startDate.getMonth() + 1 + '').length === 1) {
            data.parameters.start_date += '0' + (this.startDate.getMonth() + 1);
        }
        else {
            data.parameters.start_date += (this.startDate.getMonth() + 1) + '';
        }
        if (this.startDate.getDate().toString().length === 1) {
            data.parameters.start_date += '0' + this.startDate.getDate() + '000000';
        }
        else {
            data.parameters.start_date += this.startDate.getDate() + '000000';
        }
        if (typeof this.endDate !== 'undefined' && this.endDate !== null && this.endDate !== 0) {
            data.parameters['end_date'] = this.endDate.getFullYear() + '';
            if ((this.endDate.getMonth() + 1 + '').length === 1) {
                data.parameters['end_date'] += '0' + (this.endDate.getMonth() + 1);
            }
            else {
                data.parameters['end_date'] += (this.endDate.getMonth() + 1) + '';
            }
            if (this.endDate.getDate().toString().length === 1) {
                data.parameters['end_date'] += '0' + this.endDate.getDate() + '000000';
            }
            else {
                data.parameters['end_date'] += this.endDate.getDate() + '000000';
            }
        }
        //Set Sales Order Date fields...  
        data.parameters['sales_order_start_date'] = data.parameters['start_date'].substring(0, 4) + '-' + data.parameters['start_date'].substring(4, 6) + '-' + data.parameters['start_date'].substring(6, 8);
        data.parameters['sales_order_end_date'] = data.parameters['end_date'].substring(0, 4) + '-' + data.parameters['end_date'].substring(4, 6) + '-' + data.parameters['end_date'].substring(6, 8);
        // And lose the Start/End Dates
        delete data.parameters.start_date;
        delete data.parameters.end_date;
        console.info('ODS Search Parameters: ', data.parameters);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendForODS',
                script: '/validation/odsTables',
                email: this.env.user.email,
                data: data,
                token: this.env.user.token
            }
        });
    };
    DetailValidationOdsController.prototype.loseUndefined = function (paramsToCheck, params) {
        for (var _i = 0, paramsToCheck_1 = paramsToCheck; _i < paramsToCheck_1.length; _i++) {
            var p = paramsToCheck_1[_i];
            if (angular.isUndefined(params[p])) {
                delete params[p];
            }
        }
    };
    DetailValidationOdsController.$inject = ['topic', 'env', 'socket', '$scope', 'Dialog', 'settings', 'notify', '$state'];
    return DetailValidationOdsController;
}());
var DetailValidationOdsComponent = (function () {
    function DetailValidationOdsComponent() {
        this.templateUrl = 'detail-validation-ods.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidationOdsController;
    }
    return DetailValidationOdsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('search', '/public/images/ic_search_black_24px.svg');
})
    .component('detailValidationOds', new DetailValidationOdsComponent());

//# sourceMappingURL=detail.validation.ods.component.js.map
